<template>
  <div class="help-page-layout w-100">
    <div class="back-btn mb-2" @click="$router.back()">{{ $lang.messages.back }}</div>
    <div class="text-center mb-3">
      <img alt="logo" src="./../assets/img/logo-new.svg" class="logo" @click="$router.push('/')">
    </div>
    <div class="help-page-container">
      <HelpLinks v-on:goforgot="$router.push('/recover')"/>
    </div>
  </div>
</template>

<script>
import HelpLinks from  "@/components/HelpLinks";

export default {
  name: "Help",
  components: {
    HelpLinks,
  },
}
</script>

<style lang="scss">
.help-page-layout {
  min-height: 100%;
  background: #F5F7FB;
  padding: 40px;
}

.help-page-container {
  max-width: 450px;
  margin: 0 auto;
}
</style>